import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Pencil, Trash2, ShieldCheck } from 'lucide-react';

const ROLLER = [
  { id: 'admin',    navn: 'Admin (full tilgang)' },
  { id: 'regnskap', navn: 'Regnskap (skrive)' },
  { id: 'revisor',  navn: 'Revisor (kun lese)' },
  { id: 'ansatt',   navn: 'Ansatt (kun skann/mobil)' },
];

const Brukere = () => {
  const { user: meg } = useAuth();
  const [liste, setListe] = useState([]);
  const [open, setOpen] = useState(false);
  const [redigerer, setRedigerer] = useState(null);
  const [skjema, setSkjema] = useState({});

  const last = async () => setListe((await api.get('/brukere')).data);
  useEffect(() => { last(); }, []);

  const aapneNy = () => {
    setRedigerer(null);
    setSkjema({ epost: '', navn: '', passord: '', rolle: 'regnskap' });
    setOpen(true);
  };
  const aapneRediger = (u) => {
    setRedigerer(u);
    setSkjema({ navn: u.navn, rolle: u.rolle, nytt_passord: '' });
    setOpen(true);
  };

  const lagre = async () => {
    try {
      if (redigerer) await api.put(`/brukere/${redigerer.id}`, skjema);
      else await api.post('/brukere', skjema);
      setOpen(false); last();
    } catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };

  const slett = async (u) => {
    if (!window.confirm(`Slett bruker ${u.epost}?`)) return;
    try { await api.delete(`/brukere/${u.id}`); last(); }
    catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };

  if (meg?.rolle !== 'admin') {
    return (
      <>
        <PageHeader title="Brukere" />
        <Card><p className="fm-text-muted">Kun admin har tilgang til brukeradministrasjon.</p></Card>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Brukere" subtitle="Brukerkontoer og roller"
        actions={<button className="btn-primary" onClick={aapneNy}><Plus size={14} /> Ny bruker</button>} />

      <Card style={{ padding: 0 }}>
        <table>
          <thead><tr><th>E-post</th><th>Navn</th><th>Rolle</th><th>2FA</th><th></th></tr></thead>
          <tbody>
            {liste.map((u) => (
              <tr key={u.id}>
                <td><strong>{u.epost}</strong>{u.id === meg.id && <span className="badge badge-info" style={{ marginLeft: 6 }}>deg</span>}</td>
                <td>{u.navn || '—'}</td>
                <td><span className={`badge ${u.rolle === 'admin' ? 'badge-warning' : u.rolle === 'revisor' ? 'badge-neutral' : u.rolle === 'ansatt' ? 'badge-success' : 'badge-info'}`}>{u.rolle}</span></td>
                <td>{u.totp_aktivert ? <ShieldCheck size={14} style={{ color: 'var(--theme-success)' }} /> : <span className="fm-text-muted">—</span>}</td>
                <td>
                  <div className="flex" style={{ gap: 4 }}>
                    <button className="btn-ghost" onClick={() => aapneRediger(u)}><Pencil size={12} /></button>
                    {u.id !== meg.id && (
                      <button className="btn-ghost" onClick={() => slett(u)} style={{ color: 'var(--theme-danger)' }}><Trash2 size={12} /></button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)}
             title={redigerer ? `Rediger ${redigerer.epost}` : 'Ny bruker'}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gap: 10 }}>
          {!redigerer && (
            <div><label>E-post</label>
              <input type="email" value={skjema.epost || ''} onChange={(e) => setSkjema({ ...skjema, epost: e.target.value })} /></div>
          )}
          <div><label>Navn</label>
            <input value={skjema.navn || ''} onChange={(e) => setSkjema({ ...skjema, navn: e.target.value })} /></div>
          <div><label>Rolle</label>
            <select value={skjema.rolle || 'regnskap'} onChange={(e) => setSkjema({ ...skjema, rolle: e.target.value })}>
              {ROLLER.map((r) => <option key={r.id} value={r.id}>{r.navn}</option>)}
            </select></div>
          <div><label>{redigerer ? 'Nytt passord (la stå tomt for å beholde)' : 'Passord (min 8 tegn)'}</label>
            <input type="password"
                   value={redigerer ? (skjema.nytt_passord || '') : (skjema.passord || '')}
                   onChange={(e) => setSkjema(redigerer
                     ? { ...skjema, nytt_passord: e.target.value }
                     : { ...skjema, passord: e.target.value })} /></div>
        </div>
      </Modal>
    </>
  );
};

export default Brukere;
